export const PAY_NOW_STEPS = [
  'AMOUNT',
  'PAYMENT_METHOD'
];

export const PAY_NOW_AMOUNT_OPTION_ENTIRE = 'PAY_NOW_AMOUNT_OPTION_ENTIRE';
export const PAY_NOW_AMOUNT_OPTION_PARTIAL = 'PAY_NOW_AMOUNT_OPTION_PARTIAL';
export const PAY_NOW_AMOUNT_OPTION_PAST_DUE = 'PAY_NOW_AMOUNT_OPTION_PAST_DUE';
export const PAY_NOW_AMOUNT_OPTION_NEXT = 'PAY_NOW_AMOUNT_OPTION_NEXT';
export const PAY_NOW_AMOUNT_OPTION_LATE = 'PAY_NOW_AMOUNT_OPTION_LATE';

export const PAY_NOW_SCHEDULE_OPTION_TODAY = 'PAY_NOW_SCHEDULE_OPTION_TODAY';
export const PAY_NOW_SCHEDULE_OPTION_FUTURE = 'PAY_NOW_SCHEDULE_OPTION_FUTURE';

export const PAY_NOW_METHOD_DEBIT_CARD = 'PAY_NOW_METHOD_DEBIT_CARD';
export const PAY_NOW_METHOD_REMOTE_CHECK = 'PAY_NOW_METHOD_REMOTE_CHECK';

export const PAY_NOW_PHASE_AMOUNT = 5;
export const PAY_NOW_PHASE_SCEHDULE = 10;
export const PAY_NOW_PHASE_PAY = 15;
export const PAY_NOW_PHASE_CONFIRM_PAY = 20;

export const PAY_NOW_ACTION_RESET = 'PAY_NOW_ACTION_RESET';
export const PAY_NOW_ACTION_RESET_FAILURE = 'PAY_NOW_ACTION_RESET_FAILURE';
export const PAY_NOW_ACTION_PURCHASE = 'PAY_NOW_ACTION_PURCHASE';
export const PAY_NOW_ACTION_SIMULATE_UNSCHEDULED_PAYMENT = 'PAY_NOW_ACTION_SIMULATE_UNSCHEDULED';


export const PAY_NOW_ACTION_SIMULATE_UNSCHEDULED_PAYMENT_REQUEST = 'PAY_NOW_ACTION_SIMULATE_UNSCHEDULED_PAYMENT_REQUEST';
export const PAY_NOW_ACTION_SIMULATE_UNSCHEDULED_PAYMENT_SUCCESS = 'PAY_NOW_ACTION_SIMULATE_UNSCHEDULED_PAYMENT_SUCCESS';
export const PAY_NOW_ACTION_SIMULATE_UNSCHEDULED_PAYMENT_FAILURE = 'PAY_NOW_ACTION_SIMULATE_UNSCHEDULED_PAYMENT_FAILURE';

export const PAY_NOW_ACTION_APPLY_UNSCHEDULED_PAYMENT_REQUEST = 'PAY_NOW_ACTION_APPLY_UNSCHEDULED_PAYMENT_REQUEST';
export const PAY_NOW_ACTION_APPLY_UNSCHEDULED_PAYMENT_SUCCESS = 'PAY_NOW_ACTION_APPLY_UNSCHEDULED_PAYMENT_SUCCESS';
export const PAY_NOW_ACTION_APPLY_UNSCHEDULED_PAYMENT_FAILURE = 'PAY_NOW_ACTION_APPLY_UNSCHEDULED_PAYMENT_FAILURE';

export const payNowMethodToIntl = {
  [PAY_NOW_METHOD_DEBIT_CARD] : 'payment.method.debit',
  [PAY_NOW_METHOD_REMOTE_CHECK] : 'payment.method.remoteCheck'
};




// WEBPACK FOOTER //
// ./src/pay-now/constants.js